module.exports = __webpack_public_path__ + "6b3801d8917b7ced1dcde90fd9f4a210.png";